import React from 'react';
import Header from './components/Header';
import EmailForm from './components/EmailForm';
import Footer from './components/Footer';
import './App.css';


function App() {
  // Replace with your actual logo URL
  const logoUrl = null; // Set to your image URL or null to hide


  return (
    <div className="App">
      <Header logo={logoUrl} />
      <main className="main-content">
        <EmailForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;
